<template>
  <v-navigation-drawer app
                       v-model="opened"
                       color="white">

    <v-list class="pa-0">
      <v-list-item class="fundo-logo" style="height: 61px">
        <v-list-item-title>
          <app-logo height="47px"/>
        </v-list-item-title>
      </v-list-item>
      <v-divider/>
    </v-list>
    <v-list class="menu-list" nav dense>
      <v-list-group v-for="m of menu" :key="m.title" 
        :append-icon="m.childrens && m.childrens.length > 0 ? '$expand' : ''"
        :value="false">
        <template v-slot:activator>
          <v-list-item class="v-list-item-pai" v-if="m.link !== '#'" :to="m.link">
            <v-list-item-title>
              <v-icon color="#FFCA01">{{m.icon}}</v-icon> {{ m.title }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="v-list-item-pai" v-else>
            <v-list-item-title>
              <v-icon color="#FFCA01">{{m.icon}}</v-icon> {{ m.title }}
            </v-list-item-title>
          </v-list-item>
        </template>
        <v-list-item link class="ml-6" v-for="menuCadastroItem of m.childrens" :prepend-icon="menuCadastroItem.icon"
          :to="menuCadastroItem.link"
          :key="menuCadastroItem.link">
          <v-list-item-title>
            <v-icon color="#188BC6">{{menuCadastroItem.icon}}</v-icon> {{ menuCadastroItem.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list-group>      
      <v-list-group append-icon="" @click="onClickLogout">
        <template v-slot:activator>
          <v-list-item-title class="v-list-item-pai">
            <v-icon>mdi-logout</v-icon> Sair
          </v-list-item-title>
        </template>        
      </v-list-group>
    </v-list>
    <v-list class="pa-0">
      <v-divider/>
      <v-list-item class="fundo-apoio" style="height: 50px">
        <v-list-item-title align="center">
          <img src="../../assets/SEBRAE-colorida.png" alt="Logo do SEBRAE"  style="width: 50%"/>
        </v-list-item-title>
      </v-list-item>
      <v-list-item class="fundo-apoio" style="height: 50px">
        <v-list-item-title align="center">
          <img src="../../assets/ABPIP-colorida.png" alt="Logo do ABPIP"  style="width: 50%"/>
        </v-list-item-title>
      </v-list-item>      
      <v-divider/>      
      <v-list-item @click="onClickLogout">
        <v-list-item-icon>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            Sair
            <div class="versao">Versão: {{appVersion}} </div>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </v-list>
  </v-navigation-drawer>
</template>

<script>
// import GlobalSearch from "./GlobalSearch";
import AppLogo from "./AppLogo";
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
  name: "AppMenu",
  components: {AppLogo},
  data() {
    return {
      appVersion: PACKAGE_VERSION,
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated', 'menu', 'authorizedLinks']),
    opened: {
      get () {
        return this.$store.state.menu.opened
      },
      set(value) {
        this.SET_OPENED(value);
      }
    },
    userName: {
      get() {
        return this.user.nome;
      }
    }
  },
  methods: {
    ...mapMutations('menu',['SET_OPENED']),
    ...mapActions('auth',['doLogout', 'getDefaultLoginPage']),
    async onClickLogout() {
      await this.doLogout();
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .fundo-logo {
      background-color: #075084 !important;
    }
    .fundo-apoio {
      padding: 0 !important;
    }    
    .menu-list {
      flex: 1;
      overflow: auto;
    }

  }

  .field-name {
    max-width: 190px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

}
.v-list-item-pai {
  padding: 0 !important;
}
.versao {
  font-size: 0.6rem;
  text-align: left;
}
</style>